module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_1_sub2-f253506e077c41d85ea2d46c85eca5de.png";